export default __webpack_public_path__ + "e7cbcca94d243cbcb2713e762cd33381.svg";